import { forwardRef, useCallback, useEffect, useImperativeHandle, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useLocation } from 'react-router-dom';
import { CircularProgress, IconButton } from '@mui/material';
import { IRefRegisterUrlData, IRegisterUrlData } from 'entities';
import { useRegisterForm } from '../../context';
import { UserController } from '../../controller/UserController';
import { slugify } from '../../utils/slugify';
import { Input } from '../Inputs/Input';
import { Container, Content } from './styles';

export const RegisterUrl = forwardRef<IRefRegisterUrlData>((_, ref) => {
  const location = useLocation();
  const color =
    location.pathname === '/naturalPersonAccount' || location.pathname === '/legalPersonAccount'
      ? 'background'
      : 'background_white';
  const [isLoading, setIsLoading] = useState(false);
  const { url, formSubmited } = useRegisterForm();

  const defaultValues = {
    url,
  };

  const {
    control,
    setError,
    setValue,
    clearErrors,
    watch,
    formState: { errors },
  } = useForm({
    reValidateMode: 'onChange',
    defaultValues,
  });

  const data = watch();

  const dominio = 'legalcontrolhub.com.br/';
  const maxWidth = 400;
  const [displayText, setDisplayText] = useState(dominio);

  const checkHasError = useCallback(async () => {
    let hasError = false;
    const newUrl = slugify(data.url);
    if (!newUrl) {
      setError('url', { type: 'manual', message: 'Campo URL é obrigatório' });
      hasError = true;
    } else {
      clearErrors('url');
      setIsLoading(true);
      const exits = await UserController.urlAlreadyExists(newUrl).finally(() => {
        setIsLoading(false);
      });
      if (exits) {
        setError('url', { type: 'manual', message: 'URL já existe' });
        hasError = true;
      } else {
        clearErrors('url');
      }
    }
    return hasError;
  }, [data.url]);

  const handleUpdateUrlData = async () => {
    const hasError = await checkHasError();
    const newData: IRegisterUrlData = {
      url: slugify(data.url),
      hasError,
    };
    return newData;
  };

  useImperativeHandle(ref, () => ({
    handleUpdateUrlData,
  }));

  useEffect(() => {
    setValue('url', url);
  }, [setValue, url]);

  useEffect(() => {
    const checkScreenWidth = () => {
      if (window.innerWidth <= maxWidth) {
        setDisplayText('...hub.com.br/');
      } else {
        setDisplayText(dominio);
      }
    };

    window.addEventListener('resize', checkScreenWidth);
    checkScreenWidth();
  }, [dominio]);

  return (
    <Container color={color} id="profile-url">
      <Content>
        <p>{displayText}</p>
        <Input
          control={control}
          name="url"
          placeholder="URL"
          onChange={(e) => {
            const { value } = e.target;
            setValue('url', slugify(value));
          }}
          error={formSubmited ? !!errors.url : false}
          errorText={formSubmited ? errors.url?.message : ''}
          endAdornment={
            isLoading ? (
              <IconButton disabled>
                <CircularProgress size={20} />
              </IconButton>
            ) : undefined
          }
        />
      </Content>
    </Container>
  );
});
